import React from "react";
import { Box, Button } from "@mui/material";
import { JourneyProfileInfo } from "./JourneyProfileInfo";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  tooltipRoot: {
    background: "#fff",
    borderRadius: 8,
    padding: 16,
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
    width: "90vw",
    maxWidth: 500,
    boxSizing: "border-box",

    [theme.breakpoints.up("sm")]: {
      width: "auto",
      maxWidth: 500,
    },
  },

  scrollableContent: {
    maxHeight: "50vh",
    overflowY: "auto",

    // used to offset padding of the container for the scrollbar
    paddingRight: 8,
    marginRight: -8,
  },

  controlsWrapper: {
    marginTop: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      gap: theme.spacing(1),
    },
  },

  buttonGroup: {
    display: "flex",
    gap: theme.spacing(1),

    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },

  button: {
    padding: "6px 12px",
    [theme.breakpoints.down("xs")]: {
      flex: 1,
      padding: "4px 8px",
      fontSize: "0.8rem",
    },
  },
}));

function JourneyCustomTooltip({
  step,
  skipProps,
  primaryProps,
  backProps,
  tooltipProps,
  profileName,
  profileSubtitle,
  profileAvatar,
  showProfileInfo,
  stepIndex,
  totalSteps,
}) {
  const s = useStyles();

  const { title: _skipTitle, ...cleanSkipProps } = skipProps;
  const { title: _backTitle, ...cleanBackProps } = backProps;
  const { title: _primaryTitle, ...cleanPrimaryProps } = primaryProps;

  const hideNextBtn = step?.spotlightClicks === true;

  return (
    <Box {...tooltipProps} className={s.tooltipRoot}>
      <Box className={s.scrollableContent}>
        {showProfileInfo && (
          <JourneyProfileInfo
            profileName={profileName}
            profileAvatar={profileAvatar}
            profileSubtitle={profileSubtitle}
          />
        )}
        {step.content}
      </Box>

      <Box className={s.controlsWrapper}>
        <Button {...cleanSkipProps} className={s.button} variant="outlined">
          Skip
        </Button>

        <Box className={s.buttonGroup}>
          {stepIndex !== 0 && (
            <Button {...cleanBackProps} className={s.button} variant="outlined">
              Back
            </Button>
          )}
          {!hideNextBtn && (
            <Button
              {...cleanPrimaryProps}
              className={s.button}
              variant="contained"
            >
              {stepIndex < totalSteps - 1 ? "Next" : "Finish"}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default JourneyCustomTooltip;
